import { toast } from 'react-toastify';
import api from './api';

export const cockpitService = async (cockpitData) => {
  try {
    const requestData = {
      header: {
        iddossie: cockpitData.iddossie,
        idusuario: cockpitData.idusuario,
        esteira: cockpitData.esteira,
        userIP: cockpitData.userIP,
      },
      payload: {
        in: cockpitData.in,
        out: cockpitData.out,
        observacao: cockpitData.observacao,
      },
      request: {
        type: cockpitData.type,
        options: cockpitData.options,
      },
    };

    const requestApi = await api();
    const { data } = await requestApi.post('/cockpit/RegistrarEstimulo', requestData);
    return data;
  } catch (error) {
    toast.error(`Falha ao realizar estímulo ${cockpitData.observacao} para tipo "${cockpitData.type}".`);
    return false;
  }
};
